// Re-export domain types for KYB
import { api as kycbApi } from '@repo/api-kit/kycb';

export type ApiGetKybResponse = kycbApi.kyb.firstparty.v1.ApiGetKybResponse;
export type ApiKybStatus = kycbApi.kyb.firstparty.v1.ApiKybStatus;
export type ApiFlexKybStatus = kycbApi.kyb.firstparty.v1.ApiFlexKybStatus;

export const ApiKybStatus = kycbApi.kyb.firstparty.v1.ApiKybStatus;
export const ApiFlexKybStatus = kycbApi.kyb.firstparty.v1.ApiFlexKybStatus;
